
export enum Privilege {
  ManageCustomersProfiles = 'ManageCustomersProfiles',
  ManageFleetsProfiles = 'ManageFleetsProfiles',
  ManageInvoices = 'ManageInvoices',
  ManageContractsSales = 'ManageContractsSales'
}
